import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import { blackRGBA } from '../../../../../../../../styling/theme';

export const returnAddOrganizationStyle = ({ nodeType }) => {
  if (nodeType === 'skill_organization') {
    return css`
      /* align-self: baseline;
      margin-top: 45px; */
    `;
  }

  return null;
};

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto min-content;
  grid-template-rows: 1fr auto;
  align-items: center;
  align-self: start;
  margin-bottom: 10px;
  font-size: 12px;

  // Animations
  opacity: 1;
  height: 100%;
  transition: all 0.3s ease-in-out;
  transition-property: height, margin-top, opacity;

  //Approach 2
  /* transform: translateY(0);
  transform-origin: top;
  visibility: visible;
  z-index: 1;
  transition: all 0.25s ease-in-out
  transition-property: transform; */

  ${(props) => {
    const { newlyAddedItem } = props;

    if (newlyAddedItem)
      return css`
        height: 0;
        margin-bottom: 0;
        /* margin-top: -10px; */
        opacity: 0;

        // Approach 2
        /* transform: translateY(-100%);
        transform-origin: top;
        visibility: hidden;
        overflow: hidden;
        z-index: -1; */
      `;
    return null;
  }}

  &:hover {
    .drag-signifier {
      display: ${(props) => (!props.dragType ? 'block' : null)};
      cursor: grab;
    }
  }

  ${(props) => {
    const { type } = props;
    if (type === 'skill_organization')
      return css`
        grid-template-rows: 1fr auto;
      `;
    return null;
  }}
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

export const DragWrapper = styled.div`
  display: none;
  margin: 0 4px 0 0;
  user-select: none;
  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'skill_organization') {
      return css`
        margin: 24px 6px 0 0;
      `;
    }
    return null;
  }}
`;

export const OrdinalWrapper = styled.div`
  pointer-events: auto;
  position: absolute;
  left: -40px;
  grid-row: 1/2;
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  padding-top: 50px;

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'skill_organization') {
      return css`
        align-items: baseline;
        padding-top: 0;
        @media ${breakpointsMinWidth.tabletSm} {
          left: -50px;
        }
      `;
    }
    return null;
  }}
`;

export const Ordinal = styled.div`
  padding-right: 20px;
  font-weight: bold;
  user-select: none;
`;

export const Children = styled.div`
  grid-row: 1/-1;
  margin-bottom: 10px;
  box-shadow: 1px 1px 8px 1px ${blackRGBA(0.1)};
  border-radius: 4px;
  background-color: white;
  align-self: start;

  max-height: ${(props) =>
    props.isCollapseChildren
      ? `${
          props.collapseHeight +
          props.collapseMarginTop +
          props.collapseMarginBottom
        }px`
      : `100%`};
  overflow: ${(props) => props.isCollapseChildren && 'hidden'};
  transition: max-height 0.3s ease-in-out;

  ${(props) => {
    const {
      nodeType,
      isCollapseChildren,
      collapseHeight,
      collapseMarginBottom,
    } = props;

    if (nodeType === 'skill_organization') {
      return css`
        padding-bottom: 8px;
        max-height: ${isCollapseChildren
          ? `${collapseHeight + collapseMarginBottom}px`
          : `100%`};
        @media ${breakpointsMinWidth.tabletSm} {
          max-height: ${isCollapseChildren ? `${collapseHeight}px` : `100%`};
        }

        @media ${breakpointsMinWidth.tabletLg} {
          max-height: ${isCollapseChildren
            ? `${collapseHeight + collapseMarginBottom}px`
            : `100%`};
        }
      `;
    }
    if (nodeType === 'personalInfo') {
      return css`
        justify-self: baseline;
        margin-top: 20px;
        margin-bottom: 24px;
        padding: 22px;
        width: 100%;
        position: relative;
        height: auto;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 20px;
        @media ${breakpointsMinWidth.tabletSm} {
          grid-template-columns: repeat(4, 1fr);
          grid-gap: 12px;
        }
        @media ${breakpointsMinWidth.tabletMd} {
          padding: 22px;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          grid-template-columns: repeat(6, 1fr);
          padding: 28px;
          grid-gap: 16px;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          grid-template-columns: repeat(12, 1fr);
          grid-gap: 20px;
        }
      `;
    }
    return null;
  }};
`;

export const AddOrganization = styled.div`
  grid-row: 1/2;
  justify-self: center;
  pointer-events: auto;
  cursor: pointer;
  padding-left: 10px;
  user-select: none;
  margin-top: 15px;
  ${(props) => returnAddOrganizationStyle(props)}
`;
export const OrganizationButtonsWrapper = styled.div`
  grid-row: 1/2;
  justify-self: center;
  height: 100%;
  pointer-events: auto;
  cursor: pointer;
  margin-left: 10px;
  user-select: none;
  pointer-events: none;

  position: absolute;
  top: -13px;
  right: 3px;

  ${(props) => returnAddOrganizationStyle(props)}

  @media ${breakpointsMinWidth.tabletSm} {
    position: static;
    top: 0;
    right: 0;
  }
`;
